import React from 'react';
import { Flex, Box } from 'grid-styled';
import { Row } from './list';

const ValueRow = ({ label, value, children }) => (
    <Row>
        <Box w={1 / 2}>{label}</Box>
        <Flex w={1 / 2} style={{ fontWeight: 'bold' }}>
            {children || value}
        </Flex>
    </Row>
);

export default ValueRow;



// WEBPACK FOOTER //
// ./src/uic/ValueRow.js